import contract from 'truffle-contract';
import ChargingLedgerContract from '../../build/contracts/ChargingLedger.json';

const ChargingLedger = {
  contract: null,
  instance: null,

  init: () => {
    let self = this;
    new Promise((resolve, reject) => {
      self.contract = contract(ChargingLedgerContract);
      self.contract.setProvider(window.web3.currentProvider);
      self.instance = self.contract.deployed().then(instance => {
        return instance;
      }).catch(error => {
        reject(error);
      });
    });
  },

  addNewCharge: (charger_id, start, duration, mode) => {
    let self = this;

      // TEST
      var meta;
      self.contract.deployed().then(function(instance) {
        meta = instance;
        return meta.addNewCharge(charger_id, start, duration, mode, {from: window.web3.eth.accounts[0]});
      }).then(function(result) {
        // If this callback is called, the transaction was successfully processed.
        alert("Transaction successful!")
      }).catch(function(e) {
        // There was an error! Handle it.
      })

    return new Promise((resolve, reject) => {
      console.log(charger_id, start, duration, mode);
      self.instance.addNewCharge(charger_id, start, duration, mode, {from: window.web3.eth.accounts[0]})
        .then(response => {resolve(response)})
        .catch(error => {reject(error)});
    });
  },

  getChargesList: () => {
    let self = this;
    return new Promise((resolve, reject) => {
      self.instance
        .then(ChargingLedger => {
          return ChargingLedger.getChargesList();
        })
        .then(ChargesList => {
          console.log(ChargesList);
          resolve(ChargesList);
        })
        .catch(error => {
          console.error(error);
        });
    });
  },

  getUsersList: () => {
    let self = this;
    return new Promise((resolve, reject) => {
      self.instance
        .then(ChargingLedger => {
          return ChargingLedger.getUsersList();
        })
        .then(UsersList => {
          console.log(UsersList);
          resolve(UsersList);
        })
        .catch(error => {
          console.error(error);
        });
    });
  },

  getUserBalance: (user_id) => {
    let self = this;
    return new Promise((resolve, reject) => {
      self.instance
        .then(ChargingLedger => {
          return ChargingLedger.getUserBalance(user_id);
        })
        .then(UserBalance => {
          console.log(Number(UserBalance));
          resolve(UserBalance);
        })
        .catch(error => {
          console.error(error);
        });
    });
  },

  getChargeInfo: (charge_id) => {
    let self = this;
    return new Promise((resolve, reject) => {
      self.instance
        .then(ChargingLedger => {
          return ChargingLedger.getChargeInfo(charge_id);
        })
        .then(ChargeInfo => {
          console.log(ChargeInfo);
          resolve(ChargeInfo);
        })
        .catch(error => {
          console.error(error);
        });
    });
  },

};

export default ChargingLedger;


// WEBPACK FOOTER //
// ./src/utils/contractInstance.js